module.exports = __webpack_public_path__ + "img/character_w.808a9fdd.svg";